import FriendsList from "./FriendsList";

export const routes = [
    {
        path: "/friends/:userId",
        component: FriendsList,
        exact: true,
        showNav: true
    }
]